import { OrderRouteService } from 'common/data';
import { findParams } from 'core/utils';
import { BaseService } from 'core/services';

class OrderService extends BaseService {
	constructor(apiClient) {
		super(apiClient, new OrderRouteService());
	}

	find(filter) {
		var url = this.routeService.find(filter);
		return this.apiClient.post(url, findParams(filter));
	}

	getUnlinkedOrderLines(filter) {
		var url = this.routeService.getUnlinkedOrderLines(filter);
		return this.apiClient.post(url, findParams(filter));
	}

	createOrdersBulk(orders, sourceOfChange) {
		var url = this.routeService.createOrdersBulk(orders, sourceOfChange);
		return this.apiClient.post(url, orders);
	}

	replace(replaceParams, sourceOfChange) {
		const url = this.routeService.replace(replaceParams, sourceOfChange);
		return this.apiClient.post(url, replaceParams);
	}

	validateOrderAddress(order) {
		var url = this.routeService.validateOrderAddress(order);
		return this.apiClient.put(url, order);
	}

	getDistinctValues(distinctSearchParams) {
		var url = this.routeService.getDistinctValues();
		return this.apiClient.post(url, distinctSearchParams);
	}

	updateOrderInfo(order, sourceOfChange) {
		var url = this.routeService.updateOrderInfo(order, sourceOfChange);
		return this.apiClient.put(url, order);
	}

	cancelMarketplaceOrder(resource, sourceOfChange) {
		var url = this.routeService.cancelMarketplaceOrder(resource, sourceOfChange);
		return this.apiClient.put(url, resource);
	}

	uncancelMarketplaceOrder(resource, sourceOfChange) {
		var url = this.routeService.uncancelMarketplaceOrder(resource, sourceOfChange);
		return this.apiClient.put(url, resource);
	}

	onHold(onHoldParams, sourceOfChange) {
		const url = this.routeService.onHold(onHoldParams, sourceOfChange);
		return this.apiClient.post(url, onHoldParams);
	}

	updateOrderType(params, sourceOfChange) {
		var url = this.routeService.updateOrderType(params, sourceOfChange);
		return this.apiClient.put(url, params);
	}
}

export default OrderService;
